// extracted by mini-css-extract-plugin
export var orderDetails = "_rt-2";
export var orderImage = "_rt-1";
export var orderMeta = "_rt-3";
export var orderSummary = "_rt-0";
export var rightArrow = "_rt-4";